import { departmentFilter } from 'containers/Pages/People/Personnel/Layouts/options.jsx';
import { filterOptions } from 'utils/methods/helpers';

export const filters = ({
  bizClients,
  sites,
  businessClient,
  userAssignedDepartments = [],
}) => {
  const departmentFilterField = departmentFilter(userAssignedDepartments);
  return {
    RegularFilters: [
      {
        label: 'Archived',
        field: 'archived',
        type: 'toggle',
      },
      {
        label: 'businessClient',
        field: 'businessClient',
        type: 'select',
        options: bizClients,
      },
      {
        label: 'site',
        field: 'site',
        type: 'select',
        options: filterOptions({
          options: sites,
          filterKey: 'businessClientId',
          filterValue: businessClient,
        }),
      },
    ],
    AdvancedFilters: [...departmentFilterField],
  };
};
